export const appTypes = {
    SELECT_LEFT_MENU: "selectLeftMenu",
    SELECT_TOP_MENU: "selectTopMenu",
    THEME: "setTheme",
    API_SUCCESS: 'SUCCESS',
    API_ERROR: 'ERROR',
    API_CLEAR: 'CLEAR',
    USER_ACCOUNT_MENU: "userAccountMenu"
}